import { request, setToken, subscribe } from "../ws/client";

export const setAuthToken = setToken;
export const subscribeEvents = subscribe;

export function login(username, password) {
    return request("login", { username, password });
}

export function refreshToken(token) {
    return request("refreshToken", { token });
}

export function checkLogin(token) {
    return request("checkLogin", { token });
}

export function getDailyList() {
    return request("getDailyList");
}

export function getDailyListMetadata() {
    return request("getDailyListMetadata");
}

export function createDailyList() {
    return request("createDailyList");
}

export function getDatabase() {
    return request("getDatabase");
}

export function getCorrectOrder() {
    return request("getCorrectOrder");
}

export function getVoorraad() {
    return request("getVoorraad");
}

export function forceUpdateVoorraad() {
    return request("forceUpdateVoorraad");
}

export function getNameByOrderId(id) {
    return request("getNameByOrderId", { id });
}

export function getItemHistory(id) {
    return request("getItemHistory", { id });
}

export function changeOrderWithinMeter(id, meter, itemIdNext) {
    return request("changeOrderWithinMeter", { id, meter, itemIdNext });
}

export function setProp(propName, id, value) {
    return request("setProp", { propName, id, value });
}

export function addItem(item) {
    return request("addItem", { item });
}

export function updateDailyListNode(id, date) {
    return request("updateDailyListNode", { id, date });
}

export function addImg(id, base64) {
    return request("addImg", { id, base64 });
}
